<template>
  <div class="section-favorites">
    <div class="container">
      <div class="great-title"><slot name="title"></slot></div>
      <div class="products">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.section-favorites {
  padding-bottom: 5em;
}
.products {
  margin-top: 2em;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 5em 3em;
}
@media screen and (max-width: 767px) {
  .products {
    grid-template-columns: repeat(2, 1fr);
    gap: 5em 1em;
  }
}
</style>
